import { render, staticRenderFns } from "./baikexiangqing_mobile.vue?vue&type=template&id=b27bbd02&scoped=true"
import script from "./baikexiangqing_mobile.vue?vue&type=script&lang=js"
export * from "./baikexiangqing_mobile.vue?vue&type=script&lang=js"
import style0 from "./baikexiangqing_mobile.vue?vue&type=style&index=0&id=b27bbd02&prod&lang=less&scoped=true"
import style1 from "./baikexiangqing_mobile.vue?vue&type=style&index=1&id=b27bbd02&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b27bbd02",
  null
  
)

export default component.exports